<template>
  <div class="flex flex-row text-sm text-gray-500 mb-2">
    <div
      class="border-t border-l rounded-tl border-gray-400 h-2 w-7 ml-5 mt-2 "
    ></div>
    <!--    <a-->
    <!--      class="cursor-pointer"-->
    <!--      @click="scrollToMessage"-->
    <!--      >-->
    <!--      <span class="text-xs text-gray-400 ml-2 mb-2">-->
    <!--        <svg-->
    <!--          class="w-2 h-4 inline-block underline"-->
    <!--          viewBox="0 0 330.002 330.002"-->
    <!--          fill="currentColor"-->
    <!--          >-->
    <!--          <path d="M 324.001,123.25 173.997,10.75 c -5.334,-4 -12.667,-4 -18,0 L 6.001,123.25 c -6.627,4.971 -7.971,14.373 -3,21 2.947,3.93 7.451,6.001 12.012,6.001 3.131,0 6.29,-0.978 8.988,-3.001 L 164.998,41.5 306.001,147.25 c 6.629,4.972 16.03,3.627 21,-3 4.971,-6.627 3.627,-16.029 -3,-21 z" />-->
    <!--        </svg>-->
    <!--      </span>-->
    <!--    </a>-->
    <div class="mb-2">
      <a class="ml-2 flex cursor-pointer" @click="scrollToMessage">
        <div class="flex-shrink-0">
          <!--          <span-->
          <!--            class="inline-flex items-center justify-center h-4 w-4 rounded-full bg-vcarveDesktop font-open-sans text-xl"-->
          <!--          >-->
          <!--            <span class="font-medium text-xs leading-none text-white uppercase">{{-->
          <!--              initial-->
          <!--            }}</span>-->
          <!--          </span>-->
        </div>
        <span class="ml-2" v-html="replyingTo.messageSummary"> </span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopicReply",
  props: {
    replyingTo: {
      type: Object
    }
  },
  computed: {
    initial() {
      if (
        !this.replyingTo.userDisplay ||
        this.replyingTo.userDisplay.length === 0
      ) {
        return "?";
      }
      return this.replyingTo.userDisplay.charAt(0);
    }
  },
  methods: {
    scrollToMessage() {
      this.$emit("scroll-to-message", this.replyingTo);
    }
  }
};
</script>

<style scoped></style>
